import React from 'react';
import { checkSetState } from '@teammo/teammo-general-utils';
import history from 'app/routes/history';
import IActions from 'app/types/actions';
import { Link } from 'react-router-dom';

import { IClubsSelector } from 'app/types/selector';
import { Card } from 'reactstrap';
import HeaderThin from 'app/components/layout/HeaderThin';
import Button from 'app/components/general/Button';
import Tbody from 'app/components/general/Tbody';
import ClubRow from 'app/components/clubs/ClubRow';

interface IClubListProps {
  clubs: IClubsSelector;
  actions: IActions;
}

export default class ClubList extends React.Component<IClubListProps, {}> {
  static defaultProps = {
    clubs: {},
    actions: undefined,
  };

  async componentDidMount(): Promise<void> {
    await this.props.actions.getAllClubs();
  }

  UNSAFE_componentWillReceiveProps(newProps): void {
    this.setState(checkSetState(this.props, newProps));
  }

  componentDidUpdate(prevProps) {
    if (this.props.clubs.hasLoaded && this.props.clubs.clubIds.length === 0) {
      // console.log('none found', this.props, this.props.clubs.clubIds.length);
      history.push('/create-club');
    }
  }

  handleCreate = (e): void => {
    e.preventDefault();
    history.push('/create-club');
  };

  renderClubRow(clubId): React.ReactNode {
    if (this.props.clubs.clubsById !== undefined) {
      const club = this.props.clubs.clubsById[clubId];
      return (
        <ClubRow
          key={club.id}
          club={club}
          selectClub={this.props.actions.selectClub}
          deleteClub={this.props.actions.deleteClub}
          updateClub={this.props.actions.updateClub}
        />
      );
    }
    return null;
  }

  renderClubList(): React.ReactNode {
    if (this.props.clubs.clubIds !== undefined) {
      return this.props.clubs.clubIds.map((id) => this.renderClubRow(id));
    }
    return null;
  }

  render(): React.ReactNode {
    return (
      <div className="h-100 m-h-100">
        <div className="row">
          <div className="col">
            <HeaderThin title="Clubs" divider />
          </div>
        </div>
        <div className="row">
          <div className="col">
            Current club:
            {' '}
            <Link to={`/clubs/${this.props.clubs.currentClub.id}/edit`}>
              {this.props.clubs.currentClub.name}
            </Link>
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <Card className="">
              <div className="row card-title">
                <div className="col col-6 col-md-8 card-title-col">
                  <span>Select Club</span>
                </div>
                <div className="col col-6 col-md-4 btn-flex-group">
                  <div className="btn-flex-container thin-margin">
                    <Button
                      className="btn-thinner btn-thin-margin btn-success"
                      isLoading={this.props.clubs.isLoading}
                      onClick={this.handleCreate}
                    >
                      Create Club
                    </Button>
                  </div>
                </div>
              </div>
              <div className="row head-row">
                <div className="col col-6">Name</div>
                <div className="col col-6" />
              </div>
              <Tbody name="clubs">{this.renderClubList()}</Tbody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}
